import { Dialog, Transition } from "@headlessui/react";
import React, { Dispatch, Fragment, SetStateAction } from "react";

// Payment modal only
export default function PaymentModal({
  isOpen,
  setIsOpen,
  bankInfo,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  bankInfo: {
    name: string;
    agency: string;
    account: string;
  };
}) {
  function closeModal() {
    setIsOpen(false);
  }

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-70"
            leave="ease-in duration-200"
            leaveFrom="opacity-70"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/75" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md overflow-hidden rounded-2xl bg-white text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="rounded-2xl bg-primary500 p-10 leading-6 text-white"
                  >
                    Pagamento
                  </Dialog.Title>
                  <div className="p-10">
                    <p className="mb-4 text-lg font-bold text-black">
                      Para realizar o pagamento, faça uma transferência para:
                    </p>

                    <p className="pt-4 text-sm font-bold text-gray-800">{bankInfo.name}</p>

                    <p className="text-sm font-bold text-gray-800">Agência: {bankInfo.agency}</p>

                    <p className="pb-4 text-sm font-bold text-gray-800">
                      Conta: {bankInfo.account}
                    </p>

                    <p className="mb-4 text-center text-lg font-bold text-black">
                      Seu pagamento será processo dentro de 3 dias.
                    </p>
                  </div>

                  <div className="flex justify-end gap-2 border-t p-4">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-transparent bg-green-700 px-4 py-2 text-sm font-medium text-white focus:outline-none"
                      onClick={closeModal}
                    >
                      Entendi
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
